/* KineticHeadline
   Splits text into words and reveals them with a staggered word-rise.
   Optional `accent` substring is wrapped in coral with an animated brush underline.
   Optional `caret` appends a blinking caret at the end of the line.
*/
const KineticHeadline = ({
    text,
    accent,
    caret = false,
    className = "",
    delayStart = 0,
    step = 70,
    accentClass = "text-brand-coral",
}) => {
    const segments = accent && text.includes(accent)
        ? (() => {
              const i = text.indexOf(accent);
              return [
                  { t: text.slice(0, i), isAccent: false },
                  { t: accent, isAccent: true },
                  { t: text.slice(i + accent.length), isAccent: false },
              ].filter((s) => s.t.length > 0);
          })()
        : [{ t: text, isAccent: false }];

    let wordIndex = 0;

    return (
        <h1 className={className} aria-label={text}>
            {segments.map((seg, si) => {
                const words = seg.t.split(" ").filter(Boolean);
                return (
                    <span
                        key={`seg-${si}-${seg.t}`}
                        className={
                            seg.isAccent
                                ? `relative inline-block ${accentClass} font-black`
                                : "inline"
                        }
                    >
                        {words.map((w, wi) => {
                            const idx = wordIndex++;
                            const isLastWord =
                                si === segments.length - 1 && wi === words.length - 1;
                            return (
                                <span
                                    key={`w-${si}-${wi}-${w}`}
                                    className={`inline-block animate-word-rise relative ${
                                        isLastWord && caret ? "whitespace-nowrap" : ""
                                    }`}
                                    style={{
                                        animationDelay: `${delayStart + idx * step}ms`,
                                    }}
                                >
                                    {w}
                                    {!isLastWord && <span>&nbsp;</span>}
                                    {isLastWord && caret && (
                                        <span
                                            aria-hidden="true"
                                            className="inline-block w-[0.08em] h-[0.85em] align-[-0.08em] ml-1 bg-brand-coral animate-blink"
                                            style={{
                                                animationDelay: `${delayStart + 900}ms`,
                                            }}
                                        />
                                    )}
                                </span>
                            );
                        })}
                    </span>
                );
            })}
        </h1>
    );
};

export default KineticHeadline;
